import styled from 'styled-components';

import { formInputMixin } from 'core/ui/mixins';

export const Input = styled.input`
  ${formInputMixin}
`;

export default Input;
